export default __webpack_public_path__ + "static/media/p2.7341678d.jpeg";